import { CompetencyMap } from "@generated/graphql";

export enum CompetencyMapAssesmentTypeName {
  SCREENING = "Скрининг",
  ASSESSMENT = "Ассесмент",
  ADVANCED = "Расширенный",
}

export const getCompetencyMapAssesmentTypeString = (questionsTime?: CompetencyMap["questionsTime"]) => {
  if (!questionsTime) return null;

  if (questionsTime <= 1800) {
    return CompetencyMapAssesmentTypeName.SCREENING;
  }
  if (questionsTime > 1800 && questionsTime <= 5400) {
    return CompetencyMapAssesmentTypeName.ASSESSMENT;
  }

  return CompetencyMapAssesmentTypeName.ADVANCED;
};
